import {useEffect} from 'react';
import {SVD} from 'svd-js'
import {transpose, multiply, zeros, subtract} from 'mathjs'
import {Vector3} from 'three';
import {calculateRotMat, calculateRotQuat} from './visualmath';
import {wasmComputation} from './wasmComputation';
import getLeftNull from './getLeftNull';

export const Computation = (props) => {

    // this is the React component that's loaded
    // first: it runs the analysis (function runAnalysis in this file)
    //    it will try wasm and resort to standard JS library if unsuccessful
    //    results are returned in res variable
    // second: if successful, res is processed (function processComputation in this file) 
    //    it will put the result data in the data structures of this app
    //    it will call the props.storeComputation handle of this Component to put it in the state

    //outside render loop:
    useEffect( ()=>{

      if(props.doLUQ){

          //try to load wasm module:
          getLeftNull()
            .then(

              //module loaded successfully
              module =>{
                console.log('wasm module loaded')
                console.log('--------begin-------')
                const res = runAnalysis(props.nodes,props.elements,module);
                console.log('-------end--------')

                if (res.status === 'success'){
                  processComputation(props,res);
                  console.log('analysis successful')
                }
                else {
                  props.storeComputation(res,[],[])

                  console.log('error occured, showing res:')
                  console.log(res)
                }
              },

              //module not loaded
              reason => { 
                console.log('loading module failed')
                
                //lets try again using regular algorithm
                  const res = runAnalysis(props.nodes,props.elements,null);

                  if (res.status === 'success'){
                    processComputation(props,res);
                  }
                  else {
                    props.storeComputation(res,[],[])

                    console.log('error occured, showing res:')
                    console.log(res)
                  }

              }
            )
            .catch(
              e => {
                console.log('caught error in wasm algorithm')
                console.log(e)

                //lets try again using regular algorithm
                  const res = runAnalysis(props.nodes,props.elements,null);

                  if (res.status === 'success'){
                    processComputation(props,res);
                  }
                  else {
                    props.storeComputation(res,[],[])

                    console.log('error occured, showing res:')
                    console.log(res)
                  }

              }
            )
        }
        else {
          console.log('user chose not to use luq')
          console.log('--------begin-------')
          const res = runAnalysis(props.nodes,props.elements,null);
          console.log('-------end--------')

          if (res.status === 'success'){
            processComputation(props,res);
            console.log('analysis successful')
          }
          else {
            props.storeComputation(res,[],[])

            console.log('error occured, showing res:')
            console.log(res)
          } 
        }
    })

  return null;

}

const processComputation = (props,res) => {

//assumes a successful analysis was performed
//gets data from res structure and puts in the relevant state variables

var newElements = [...props.elements];
var newNodes = [...props.nodes];

if (res !== null && res.status === 'success' && res.nover > 0){
      
      const ocVecs = res.ocvecs[props.activeOCId];

      // var newElements = [...props.elements];
      var maxLength = 0;
      var maxLength_Mc = 0;
      var maxLength_Fc = 0;

      //loop over elements and compute the stress resultants
      newElements.forEach(

      (e,i) => {

        if(e.svdef_ii && e.svdef_ii.length > 0){
          var sig = e.svdef_ii.map( j => ocVecs[j] );

          if (sig && sig.length >0){
            if (e.type === 'leaf'){
              sig = [sig[0], 0, 0, 0, sig[1], sig[2]];
            }
            if (e.type === 'wire'){
              sig = [sig[0], 0, 0, 0, 0, 0];
            }
            if (e.type === 'notch'){
              sig = [sig[0], sig[1], sig[2], 0, sig[3], sig[4]];
            }

            //store sigmas per element
            e.sig = sig;

            //find coordinates of nodes connected to this element:
            //first find index of nodes given nodeid
            const ii_p = props.nodes.findIndex( no => no.id === e.connect[0]);
            const ii_q = props.nodes.findIndex( no => no.id === e.connect[1]);

            let points1 = new Vector3().fromArray(props.nodes[ii_p].coord);
            let points2 = new Vector3().fromArray(props.nodes[ii_q].coord);
            let points = [];
            points.push(points1);
            points.push(points2);

            let locY = new Vector3().fromArray(e.locY);

            let stressRes = calcStressResultants(sig,points,locY);
            e.stressRes = stressRes;

            //for the moments
            if(props.stressMode === 'moments'){
              e.stressVec_p = new Vector3().fromArray([3,4,5].map(i=>stressRes.Fp_glob[i]));
              e.stressVec_q = new Vector3().fromArray([3,4,5].map(i=>stressRes.Fq_glob[i]));
            }
            //for the forces
            if(props.stressMode === 'forces'){
              e.stressVec_p = new Vector3().fromArray([0,1,2].map(i=>stressRes.Fp_glob[i]));
              e.stressVec_q = new Vector3().fromArray([0,1,2].map(i=>stressRes.Fq_glob[i]));
            }
            e.stressVec_Mc = new Vector3().fromArray(stressRes.Mc_loc);
            e.stressVec_Fc = new Vector3().fromArray(stressRes.Fc_loc);


            if (e.stressVec_p.length() > maxLength){
              maxLength = e.stressVec_p.length();
            }
            if (e.stressVec_q.length() > maxLength){
              maxLength = e.stressVec_q.length();
            }
            if (e.stressVec_Mc.length() > maxLength_Mc){
              maxLength_Mc = e.stressVec_Mc.length();
            }
            if (e.stressVec_Fc.length() > maxLength_Fc){
              maxLength_Fc = e.stressVec_Fc.length();
            }

          }
        }
        else {
          e.stressVec_p = new Vector3();
          e.stressVec_q = new Vector3();
          e.stressVec_Mc = new Vector3();
          e.stressVec_Fc = new Vector3();
          e.sig = 0;
        }
      })
      //loop over elements again to normalize
      if (maxLength > 0.001){ //didnt pick >0 because it may be almost zero, 1e-15 etc
        newElements.forEach( (e,i) =>{
          e.stressVec_p.multiplyScalar(1/maxLength);
          e.stressVec_q.multiplyScalar(1/maxLength);
        })
      }
      if (maxLength_Mc > 0.001){ //didnt pick >0 because it may be almost zero, 1e-15 etc
        newElements.forEach( (e,i) =>{
          e.stressVec_Mc.multiplyScalar(1/maxLength_Mc);
        })
      }
      if (maxLength_Fc > 0.001){ //didnt pick >0 because it may be almost zero, 1e-15 etc
        newElements.forEach( (e,i) =>{
          e.stressVec_Fc.multiplyScalar(1/maxLength_Fc);
        })
      }
      
      // //store in state
      // props.setElements(newElements);

    }


    if (res !== null && res.status === 'success' && res.nunder > 0){
      const ucVecs = res.ucvecs[props.activeUCId];

      let threshTrans = 0.15;
      let threshRot = 35/180*Math.PI;

      let allCoords = [];
      let allTransIncrem = [];
      let allRotIncrem = [];

      newNodes.forEach((n) => (allCoords.push(...n.coord)))
      let minCoord = Math.min( ...allCoords);
      let maxCoord = Math.max( ...allCoords);
      
      //get characteristic length
      let lengthEquiv = maxCoord - minCoord;

      newNodes.forEach(
        (n,i) => {

          let ii = n.svcoord_ii;

          n.dpos = new Vector3();
          n.drot = [0,0,0,0];

          if (ii.length > 0){
            n.dpos.set(ucVecs[ii[0]], ucVecs[ii[1]], ucVecs[ii[2]]);
            n.dpos.multiplyScalar(lengthEquiv);
            n.drot = [ucVecs[ii[3]], ucVecs[ii[4]], ucVecs[ii[5]]]; //these are increments in the euler angles (infinitesimal)
          }

          //collect all coordinates in a flat array (for determining charact. length)
          // allCoords.push(...n.coord);
          
          //collect all translational increments in flat array (for determining scale factor based on translations)
          allTransIncrem.push(n.dpos.x, n.dpos.y, n.dpos.z);

          //collect all rotational increments in flat array (for determining scale factor based on rotations)
          allRotIncrem.push(...n.drot);
        }
      )


      //get scale factor based on translations
      let maxAbsTransIncrem = Math.max(...allTransIncrem.map(a => Math.abs(a)));
      let scaleTrans = maxAbsTransIncrem/(threshTrans*lengthEquiv);

      //get scale factor based on rotations
      let maxAbsRotIncrem = Math.max(...allRotIncrem.map(a => Math.abs(a)));
      let scaleRot = maxAbsRotIncrem/(threshRot);

      //determine which of the two scale factors to pick
      let temp = Math.max(scaleTrans, scaleRot);
      console.log('scaleTrans '+scaleTrans)
      console.log('scaleRot '+scaleRot)
      console.log('max '+temp)
      let scale = null;
      if (Math.abs(temp) > 0.0000001){
        scale = 1/Math.max(scaleTrans, scaleRot);
      }
      else {
        scale = 1;
      }

      newNodes.forEach( n => {
        n.dpos.multiplyScalar(scale);
        scalarMultiply(n.drot,scale);
      })

      // //store in state
      // props.setNodes(newNodes);

    }

    props.storeComputation(res,newElements,newNodes);

    return null;

}

const runAnalysis = (nodes,elements,module) => {

  console.log('start analysis')

  //---
  //process nodes, fill structure with indices for the singular vector with coordinates
  //first, collect all node numbers that are connected to elements (so that unconnected nodes can be ignored)
  let connectedNodes = [];
  elements.forEach( (e) => (connectedNodes.push(e.connect[0],e.connect[1])));


  var coord_ii = 0; //index gets incremented
  var numberFixes = 0; 
  for (var no of nodes){
    
    if(!no.fix && connectedNodes.indexOf(no.id) !== -1){
      no.svcoord_ii = [coord_ii,coord_ii+1,coord_ii+2,coord_ii+3,coord_ii+4,coord_ii+5];
      coord_ii = coord_ii + 6;
    }
    else {
      no.svcoord_ii = [];
    }

    if(no.fix && connectedNodes.indexOf(no.id) !== -1){
      //number of fixed nodes (and connected to an element)
      numberFixes++;
    }
  }

  // console.log('coord_ii length: '+coord_ii);

  if (coord_ii === 0){
    return {"status": "nofreecoord"};
  }

  if (numberFixes === 0){
    return {"status": "nofixes"};
  }

  //traverse elements structure and build up the magic Jacobian
  //first loop over elements to find out how large Jacobian will be
  var def_ii = 0; //index for the singular vector with the deformations; gets incremented
  
  elements.forEach( (el) => {
  // for (let [el_ii,el] of elements.entries()){

      //see which nodes it's connected to
      let p_ii = nodes.findIndex( n => n.id === el.connect[0]);
      let q_ii = nodes.findIndex( n => n.id === el.connect[1]);
      let p_free = !nodes[p_ii].fix;
      let q_free = !nodes[q_ii].fix;

      if(el.type === 'leaf'){ //flexible element
        if(p_free || q_free){ //one of the nodes is free
          //store def id in struct
          el.svdef_ii = [def_ii, def_ii+1, def_ii+2];
          def_ii = def_ii + 3;
        }
        else { //both nodes are fixed
          //clear def id if already in struct
          el.svdef_ii = [];
        }
      }
      else if(el.type === 'rigid'){
        if(p_free || q_free){ //one of the nodes is free
          //store def id in struct
          el.svdef_ii = [def_ii, def_ii+1, def_ii+2, def_ii+3, def_ii+4, def_ii+5];
          def_ii = def_ii + 6;
        }
        else { //both nodes are fixed
          //clear def id if already in struct
          el.svdef_ii = [];
        }
      }
      else if(el.type === 'wire'){
        if(p_free || q_free){ //one of the nodes is free
          //store def id in struct
          el.svdef_ii = [def_ii];
          def_ii = def_ii + 1;
        }
        else { //both nodes are fixed
          //clear def id if already in struct
          el.svdef_ii = [];
        }
      }
      else if(el.type === 'notch'){
        if(p_free || q_free){ //one of the nodes is free
          //store def id in struct
          el.svdef_ii = [def_ii, def_ii+1, def_ii+2, def_ii+3, def_ii+4];
          def_ii = def_ii + 5;
        }
        else { //both nodes are fixed
          //clear def id if already in struct
          el.svdef_ii = [];
        }
      }
      else {
        el.svdef_ii = [];
      }
  })
  
  // console.log('def_ii length: ' +def_ii);

  if (def_ii === 0){
    return {"status": "noconstrdef"};
  }

  const svcoord_n = Math.max(
                      ...nodes.map(n=>n.svcoord_ii).flat()
                    )+1;
  const svdef_n = Math.max(
                      ...elements.map(e=>e.svdef_ii).flat()
                    )+1;

  //check if dimensions are not zero
  // console.log('check hier')
  // console.log(svcoord_n)
  // console.log(svdef_n)
  // console.log(...elements.map(e=>e.svdef_ii).flat())


      let allCoords = [];

      nodes.forEach(
        (n) => {

          allCoords.push(...n.coord);

        }
      )

      let minCoord = Math.min( ...allCoords);
      let maxCoord = Math.max( ...allCoords);

      //get characteristic length
      let lengthEquiv = maxCoord - minCoord;

      console.log(lengthEquiv)




  
  //initialize and fill with zeros
  let J = [...Array(svdef_n)].map(x=>Array(svcoord_n).fill(0))

  //second loop over elements for computing all element contributions and building up the system Jacobian
  // for (let [el_ii,el] of elements.entries()){
  elements.forEach( (el) => {
    
    // console.log(el.id)

    //see what nodes it's connected to
    let p_ii = nodes.findIndex( n => n.id === el.connect[0]);
    let q_ii = nodes.findIndex( n => n.id === el.connect[1]);
    let p_free = !nodes[p_ii].fix;
    let q_free = !nodes[q_ii].fix;
    
    let p_coord = new Vector3().fromArray(nodes[p_ii].coord);
    let q_coord = new Vector3().fromArray(nodes[q_ii].coord);

    p_coord.multiplyScalar(1/lengthEquiv);
    q_coord.multiplyScalar(1/lengthEquiv);

    let coords = [p_coord,q_coord];
    let locY = new Vector3().fromArray(el.locY);
    let quat = calculateRotQuat(coords,locY);

    if(el.type === 'leaf'){ //flexible element

      if(p_free){
        //calculate J_el([1,5,6]) for the p_node
        let Jel = calcElementJac([1,5,6],'p',coords,quat);
        //store in J_sys at (el.svdef_ii , nodes[p_ii].svcoord_ii)
        J = fillArray(J,el.svdef_ii,nodes[p_ii].svcoord_ii,Jel);
      }
      if(q_free){
        //calculate J_el([1,5,6]) for the q_node
        let Jel = calcElementJac([1,5,6],'q',coords,quat);
        //store in J_sys at (el.svdef_ii , nodes[q_ii].svcoord_ii)
        J = fillArray(J,el.svdef_ii,nodes[q_ii].svcoord_ii,Jel);
      }
    }
    else if(el.type === 'rigid'){ //rigid element

      if(p_free){
        //calculate J_el([1,2,3,4,5,6]) for the p_node
        let Jel = calcElementJac([1,2,3,4,5,6],'p',coords,quat);
        //store in J_sys at (el.svdef_ii , nodes[p_ii].svcoord_ii)
        J = fillArray(J,el.svdef_ii,nodes[p_ii].svcoord_ii,Jel);
      }
      if(q_free){
        //calculate J_el([1,2,3,4,5,6]) for the q_node
        let Jel = calcElementJac([1,2,3,4,5,6],'q',coords,quat);
        //store in J_sys at (el.svdef_ii , nodes[q_ii].svcoord_ii)
        J = fillArray(J,el.svdef_ii,nodes[q_ii].svcoord_ii,Jel);
      }
    }
    else if(el.type === 'wire'){ //wire element

      if(p_free){
        //calculate J_el([1]) for the p_node
        let Jel = calcElementJac([1],'p',coords,quat);
        //store in J_sys at (el.svdef_ii , nodes[p_ii].svcoord_ii)
        J = fillArray(J,el.svdef_ii,nodes[p_ii].svcoord_ii,Jel);
      }
      if(q_free){
        //calculate J_el([1]) for the q_node
        let Jel = calcElementJac([1],'q',coords,quat);
        //store in J_sys at (el.svdef_ii , nodes[q_ii].svcoord_ii)
        J = fillArray(J,el.svdef_ii,nodes[q_ii].svcoord_ii,Jel);
      }
    }
    else if(el.type === 'notch'){ //rigid element

      if(p_free){
        //calculate J_el([1,2,3,5,6]) for the p_node
        let Jel = calcElementJac([1,2,3,5,6],'p',coords,quat);
        //store in J_sys at (el.svdef_ii , nodes[p_ii].svcoord_ii)
        J = fillArray(J,el.svdef_ii,nodes[p_ii].svcoord_ii,Jel);
      }
      if(q_free){
        //calculate J_el([1,2,3,5,6]) for the q_node
        let Jel = calcElementJac([1,2,3,5,6],'q',coords,quat);
        //store in J_sys at (el.svdef_ii , nodes[q_ii].svcoord_ii)
        J = fillArray(J,el.svdef_ii,nodes[q_ii].svcoord_ii,Jel);
      }
    }
  })

  console.log('jac')
  console.log(J)
  
  // ---  run svd on J ----
  // check if nrows >= ncols, otherwise transpose back and forth
  let nrows = J.length
  let ncols = J[0].length

  console.log('Dcc is ' + nrows + ' by ' + ncols)

  var u = null;
  var v = null;
  var q = null;
  if (nrows >= ncols) {
    ({u,v,q} = SVD(J,'f')); //'f' to compute the full version of u
  }
  else {
    //transpose J and swap u and v
    
    ({u:v,v:u,q} = SVD(transpose(J),'f')); //no need for left sing vectors; we do need the right sing vectors
    
    //old way of swapping
    // var {u,v,q} = SVD(transpose(J),'f'); //no need for left sing vectors; we do need the right sing vectors
    // //swap because of transpose (keep in mind javascript destructuring on the previous line with the svd call)
    // // u = [...v]; 
    // let uCopy = [...u];
    // u = v;
    // v = uCopy;
    
    // console.log('did a swap');
  }
  
  //---------
  //additional svd -- temporary
  // let {u:u2, v:v2, q:q2} = SVD(multiply(transpose(J),J),false,true); //only need v
  let {v:v2, q:q2} = SVD(multiply(transpose(J),J),false,true); //only need v
  // console.log(u2)
  // console.log(v2)
  // console.log(q2)
  var ii2 = q2.flatMap( (sv,i) => Math.abs(sv)<0.001 ? i : []); //list with indices of nearzero sing vals
  //----------------

  // process 
  var ii = q.flatMap( (sv,i) => Math.abs(sv)<0.001 ? i : []); //list with indices of nearzero sing vals
  const nsing = ii.length;
  const m = nrows
  const n = ncols;

  console.log('m is ' + m);
  console.log('n is ' + n);
  console.log('nzero sval is ' + nsing);

  // console.log('u');
  // console.log(u);
  // console.log('v');
  // console.log(v);
  // console.log('ii');
  // console.log(ii);
  // console.log('ii2');
  // console.log(ii2);

  let iiRowsExcessOfCols = [];
  let iiColsExcessOfRows = [];
  let idx = [];
  let nover = [];
  let nunder = [];
  if (m > n) {
    nover = m-n+nsing
    nunder = nsing
    
    //add indices of rows of in excess of column (those columns also correspond to overconstraint stressess and are not captured by small (zero) singular values)
    for (let i=n+1; i<=m; i++){
      iiRowsExcessOfCols.push(i-1);
    }
  } 
  else if (m < n) {
    nover = nsing
    nunder = n-m+nsing

    for (let i=m+1; i<=n; i++){
      iiColsExcessOfRows.push(i-1);
    }
  } 
  else {
    nover = nsing
    nunder = nsing
  }

  //format singular vectors
  const utransp = transpose(u); //transpose here for easy column-selection in loop
  let ocvecs = [];
  idx = ii.concat(iiRowsExcessOfCols);
  for (let i = 0; i<nover; i++) {
    let ocvec = utransp[idx[i]]; //take the *columns of u* corresponding to nearzero sing vals of *J-transposed*
    ocvecs[i] = ocvec;
  }

  const vtransp = transpose(v2); //transpose here for easy column-selection in loop
  let ucvecs = [];
  // idx = ii.concat(iiColsExcessOfRows);  //old
  idx = ii2;
  for (let i = 0; i<nunder; i++){
    let ucvec = vtransp[idx[i]];
    ucvecs[i] = ucvec;
  }

  console.log(ucvecs)  

  if (module !== null){
    console.log('attempting wasm')
    if (nrows > 100 || ncols > 100){
      throw new Error('Jacobian too large for wasm.');
    }

    // const {u: temp1, u_size: temp2, out: luq_out} = wasmComputation(J,module);
    const {u_size: usizeWasm, out: uWasm} = wasmComputation(J,module);

    const {u_size: vsizeWasm, out: vWasm} = wasmComputation(transpose(J),module);

    console.log('here');
    console.log(usizeWasm)
    // console.log(ding2)
    // console.log(ucvecs)

    if (nover !== usizeWasm[0]){
      console.log('Problem: SVD analysis predicts '+nsing+' overconstraints, LUQ '+usizeWasm[0]);
    }

    //replace with results from luq computation
    ocvecs = uWasm;

    //temporary -- give user option to choose
    //for now: replace with results from luq computation
    ucvecs = vWasm;

  }

  // console.log('ocvecs')
  // console.log(ocvecs)
  // console.log('ucvecs')
  // console.log(ucvecs)
  // console.log('nodes1')
  // console.log(nodes)
  // console.log('elements')
  // console.log(elements)

  return {"status": "success", "u":u, "v":v, "singval":q, "nearzero_i": ii, "ocvecs":ocvecs, "ucvecs":ucvecs, "nover":nover, "nunder": nunder, "nsing": nsing, "nrows": nrows, "ncols": ncols};
}



export const calcStressResultants = (sig,coords,locY) => {

  //see what nodes it's connected to
  // let p_ii = nodes.findIndex( n => n.id === el.connect[0]);
  // let q_ii = nodes.findIndex( n => n.id === el.connect[1]);
  
  // let p_coord = new THREE.Vector3().fromArray(nodes[p_ii].coord);
  // let q_coord = new THREE.Vector3().fromArray(nodes[q_ii].coord);
  // let coords = [p_coord,q_coord];
  const quat = calculateRotQuat(coords,locY);
  const R4 = calculateRotMat(coords,locY);
  const R4el = R4.elements;
  const R = [
            [R4el[0],R4el[1],R4el[2]],
            [R4el[4],R4el[5],R4el[6]],
            [R4el[8],R4el[9],R4el[10]]
            ];
  // const Rt = transpose(R);
  
  const Jp = calcElementJac([1,2,3,4,5,6],'p',coords,quat);
  const Jq = calcElementJac([1,2,3,4,5,6],'q',coords,quat);

  //nodal forces and moments in global frame
  // console.log('Jp')
  // console.log(Jp)

  // console.log('sig')
  // console.log(sig)

  const Fp_glob = multiply(transpose(Jp),sig);
  const Fq_glob = multiply(transpose(Jq),sig);

  //mesh for the elastic line (between 0 and 1)
  const lineMesh = [0, 0.25,0.5,0.75, 1];
  const meshSize = lineMesh.length;

  //initialize arrays
  let p_contrib = zeros(meshSize);
  let q_contrib = zeros(meshSize);
  let F_loc = zeros(meshSize);
  let M_loc = zeros(meshSize)
  let F_loc_x = zeros(meshSize); //normal force in x
  let F_loc_y = zeros(meshSize); //shear force in y
  let F_loc_z = zeros(meshSize); //shear force in z
  let M_loc_x = zeros(meshSize); //torsion moment about x
  let M_loc_y = zeros(meshSize); //bending moment about y
  let M_loc_z = zeros(meshSize); //bending moment about z

  //calculate stress resultants in local frame along mesh
  for (let i=0; i<meshSize; i++){
    
    p_contrib = scalarMultiply([Fp_glob[3],Fp_glob[4],Fp_glob[5]],1-lineMesh[i]);
    q_contrib = scalarMultiply([Fq_glob[3],Fq_glob[4],Fq_glob[5]],lineMesh[i]);
    M_loc = multiply(R,subtract(p_contrib,q_contrib));
    M_loc = scalarMultiply(M_loc,-1);

    M_loc_x[i] = M_loc[0];
    M_loc_y[i] = M_loc[1];
    M_loc_z[i] = M_loc[2];
    
    F_loc = multiply(R,[Fq_glob[0], Fq_glob[1], Fq_glob[2]]);
    F_loc_x[i] = F_loc[0];
    F_loc_y[i] = F_loc[1];
    F_loc_z[i] = F_loc[2];

    
  }

  //local moment and force in center (index 2 in vectors)
  const Fc_loc = [F_loc_x[2],F_loc_y[2],F_loc_z[2]];
  const Mc_loc = [M_loc_x[2],M_loc_y[2],M_loc_z[2]];

  return {"Fp_glob":Fp_glob, "Fq_glob":Fq_glob, "Fc_loc": Fc_loc, "Mc_loc": Mc_loc};

}

export const scalarMultiply = (arr, multiplier) => {
   for (var i = 0; i < arr.length; i++)
   {
      arr[i] *= multiplier;
   }
   return arr;
}

const Power = (a,b) => {return a**b}
// const transpose = m => m[0].map((x,i) => m.map(x => x[i]))

const fillArray = (arr,rii,cii,sub) => {

  var i;
  var j;
  for (i=0; i<rii.length; i++){

    var r = rii[i];

    for (j=0; j<cii.length; j++){

      var c = cii[j];
      arr[r][c] += sub[i][j];

    }

  }

  return arr;

}

export const isZero = (number) => {
  return Math.abs(number) <= 1e-7;
}

export const isNonzero = (number) => {
  return Math.abs(number) > 1e-7;
}

export const calcElementJac = (defs,node,coords,initrot) => {

  const xp = coords[0].x;
  const yp = coords[0].y;
  const zp = coords[0].z;

  const xq = coords[1].x;
  const yq = coords[1].y;
  const zq = coords[1].z;
 
  const q0 = initrot.w;
  const q1 = initrot.x;
  const q2 = initrot.y;
  const q3 = initrot.z;

  const L0 = Math.sqrt((xq-xp)**2 + (yq-yp)**2 + (zq-zp)**2);

  let J = [];
  if (node === 'p'){
    J = [
          [(xp - xq)/L0,(yp - yq)/L0,(zp - zq)/L0,0,0,0],
          [0,0,0,-(L0*(Power(q0,2) + Power(q1,2) - Power(q2,2) - Power(q3,2))*(Power(q0,2) + Power(q1,2) + Power(q2,2) + Power(q3,2))),
            -(L0*(4*q1*q2 + 4*q0*q3)*(Power(q0,2) + Power(q1,2) + Power(q2,2) + Power(q3,2)))/2.,
            (L0*(4*q0*q2 - 4*q1*q3)*(Power(q0,2) + Power(q1,2) + Power(q2,2) + Power(q3,2)))/2.],
          [2*q0*q2 + 2*q1*q3,-2*q0*q1 + 2*q2*q3,Power(q0,2) - Power(q1,2) - Power(q2,2) + Power(q3,2),
            -((Power(q0,2) - Power(q1,2) - Power(q2,2) + Power(q3,2))*(yp - yq)) + (-2*q0*q1 + 2*q2*q3)*(zp - zq),
            (Power(q0,2) - Power(q1,2) - Power(q2,2) + Power(q3,2))*(xp - xq) - 2*(q0*q2 + q1*q3)*(zp - zq),
            2*(q0*q1 - q2*q3)*(xp - xq) + 2*(q0*q2 + q1*q3)*(yp - yq)],
          [-2*q0*q2 - 2*q1*q3,2*q0*q1 - 2*q2*q3,-Power(q0,2) + Power(q1,2) + Power(q2,2) - Power(q3,2),0,0,0],
          [-2*q1*q2 + 2*q0*q3,-Power(q0,2) + Power(q1,2) - Power(q2,2) + Power(q3,2),-2*q0*q1 - 2*q2*q3,
            2*(q0*q1 + q2*q3)*(yp - yq) + (Power(q0,2) - Power(q1,2) + Power(q2,2) - Power(q3,2))*(-zp + zq),
            -2*(q0*q1 + q2*q3)*(xp - xq) + 2*(q1*q2 - q0*q3)*(zp - zq),
            (Power(q0,2) - Power(q1,2) + Power(q2,2) - Power(q3,2))*(xp - xq) - 2*(q1*q2 - q0*q3)*(yp - yq)],
          [2*q1*q2 - 2*q0*q3,Power(q0,2) - Power(q1,2) + Power(q2,2) - Power(q3,2),2*q0*q1 + 2*q2*q3,0,0,0]
        ];
  }

  if (node === 'q'){
    J = [
          [(-xp + xq)/L0,(-yp + yq)/L0,(-zp + zq)/L0,0,0,0],
          [0,0,0,L0*(Power(q0,2) + Power(q1,2) - Power(q2,2) - Power(q3,2))*(Power(q0,2) + Power(q1,2) + Power(q2,2) + Power(q3,2)),
            (L0*(4*q1*q2 + 4*q0*q3)*(Power(q0,2) + Power(q1,2) + Power(q2,2) + Power(q3,2)))/2.,
            -(L0*(4*q0*q2 - 4*q1*q3)*(Power(q0,2) + Power(q1,2) + Power(q2,2) + Power(q3,2)))/2.],
          [-2*q0*q2 - 2*q1*q3,2*q0*q1 - 2*q2*q3,-Power(q0,2) + Power(q1,2) + Power(q2,2) - Power(q3,2),0,0,0],
          [2*q0*q2 + 2*q1*q3,-2*q0*q1 + 2*q2*q3,Power(q0,2) - Power(q1,2) - Power(q2,2) + Power(q3,2),
            (Power(q0,2) - Power(q1,2) - Power(q2,2) + Power(q3,2))*(yp - yq) + 2*(q0*q1 - q2*q3)*(zp - zq),
            (Power(q0,2) - Power(q1,2) - Power(q2,2) + Power(q3,2))*(-xp + xq) + 2*(q0*q2 + q1*q3)*(zp - zq),
            (2*q0*q1 - 2*q2*q3)*(-xp + xq) - 2*(q0*q2 + q1*q3)*(yp - yq)],
          [2*q1*q2 - 2*q0*q3,Power(q0,2) - Power(q1,2) + Power(q2,2) - Power(q3,2),2*q0*q1 + 2*q2*q3,0,0,0],
          [-2*q1*q2 + 2*q0*q3,-Power(q0,2) + Power(q1,2) - Power(q2,2) + Power(q3,2),-2*q0*q1 - 2*q2*q3,
            -2*(q0*q1 + q2*q3)*(yp - yq) + (Power(q0,2) - Power(q1,2) + Power(q2,2) - Power(q3,2))*(zp - zq),
            2*(q0*q1 + q2*q3)*(xp - xq) + (-2*q1*q2 + 2*q0*q3)*(zp - zq),
            (-Power(q0,2) + Power(q1,2) - Power(q2,2) + Power(q3,2))*(xp - xq) + 2*(q1*q2 - q0*q3)*(yp - yq)]
        ];    
  }

  //change of the deformation functions 3,4,5,6, so that now sigma_3 and sigma_5 are the transverse force, and sigma_4 and sigma_6 the moment in the middle
  let new3 = [];
  let new4 = [];
  let new5 = [];
  let new6 = [];
  for(let i=0; i<6; i++){

    new3[i] = 0.5*( J[3][i] - J[2][i] );
    new4[i] = J[2][i] + J[3][i];

    new5[i] = 0.5*( J[4][i] - J[5][i] );
    new6[i] = J[4][i] + J[5][i];

  };

  J[2] = new3;
  J[3] = new4;
  J[4] = new5;
  J[5] = new6;

  return defs.map(i => J[i-1])
}

